module.exports = __webpack_public_path__ + "img/bg.6caa919b.jpg";